<!-- Common Dialog here -->
<p-dialog [id]="dialogId()" [closable]="true"  draggable="false" [header]="dialogHeader()" [modal]="true" (onHide)="closeDialog()" [(visible)]="isShowDialog"
          [style]="{ width: '400px', 'max-height': '680px' }">
    <div class="flex flex-col p-6 bg-white gap-6">
        <p class="gs-font-600 text-body">{{ title() }}</p>
        <p class="gs-text-black text-body">{{ content() }}</p>
        @if(cancelBttnText() || btnName()) {
        <div class="flex flex-row justify-items-stretch items-center w-full gap-x-3">
            @if(cancelBttnText()){ <button pButton [outlined]="true" (click)="closeDialog()" class="w-full !font-700 !text-14 h-[38px]" [label]="cancelBttnText() || ''"></button> }
            @if(btnName()){ <button pButton severity="primary" (click)="confirmDialog()" class="w-full" [label]="btnName() || ''"></button> }
        </div>
        }
    </div>
</p-dialog>